import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface PageBannerProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  crumbs: Crumb[];
}

export default function PageBanner({ eyebrow, title, desc, crumbs }: PageBannerProps) {
  return (
    <section className="border-b border-background-200 bg-gradient-to-br from-primary-100 via-background-50 to-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <nav aria-label="面包屑" className="mb-4 flex items-center gap-1.5 text-sm text-foreground-500">
          {crumbs.map((c, i) => (
            <span key={c.label} className="flex items-center gap-1.5">
              {c.to ? (
                <Link to={c.to} className="transition-colors hover:text-primary-600">
                  {c.label}
                </Link>
              ) : (
                <span className="text-foreground-700">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </span>
          ))}
        </nav>
        {eyebrow && (
          <span className="mb-2 inline-block rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display text-3xl text-foreground-900 md:text-4xl">{title}</h1>
        {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
    </section>
  );
}